import { render, staticRenderFns } from "./EditorialPush.vue?vue&type=template&id=517b106d&scoped=true"
import script from "./EditorialPush.vue?vue&type=script&lang=ts"
export * from "./EditorialPush.vue?vue&type=script&lang=ts"
import style0 from "./EditorialPush.vue?vue&type=style&index=0&id=517b106d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517b106d",
  null
  
)

export default component.exports